@if (formInitialized) {
  <form [formGroup]="form" (ngSubmit)="onSubmit()" class="p-fluid">
    <div class="flex align-items-center">
      <app-search-input (search)="onSearch($event)"></app-search-input>
      <p-button
        severity="secondary"
        size="small"
        class="ml-auto"
        [text]="true"
        [raised]="true"
        [rounded]="true"
        label="Vergleichswerte fehlen? Hier entlang"
        icon="fas fa-arrow-right"
        iconPos="right"
        [routerLink]="[
          '/data-backend',
          {
            outlets: {
              overlay: [
                'konfiguration',
                { outlets: { panel: 'vergleichswerte' } },
              ],
            },
          },
        ]" />
    </div>

    <div class="grid">
      <div class="col-5">
        <div class="grid">
          @for (compVal of comparisonStore.getDefaults(); track $index) {
            <app-form-field-wrapper
              [label]="compVal.name"
              [name]="compVal.key"
              [colSize]="12"
              [formField]="form.get(compVal.key)">
              <input
                pInputText
                [id]="compVal.key"
                type="number"
                [formControlName]="compVal.key"
                class="p-input" />
            </app-form-field-wrapper>
          }

          <div formArrayName="data" class="w-full">
            @if (filteredData && filteredData.length) {
              <div
                *ngFor="let dataControl of filteredData.controls; let i = index"
                [formGroupName]="i">
                <app-form-field-wrapper
                  [label]="
                    (dataControl.get('name')?.value ?? 'District') +
                    (' (' + dataControl.get('key')?.value + ')')
                  "
                  [name]="'value'"
                  [colSize]="12"
                  [formField]="dataControl.get('value')">
                  <input
                    pInputText
                    id="value"
                    type="number"
                    formControlName="value"
                    class="p-input" />
                </app-form-field-wrapper>
              </div>
            } @else {
              <div class="col-12">
                <app-alert severity="secondary" [canToggle]="false"
                  >Keine Treffer</app-alert
                >
              </div>
            }
          </div>
        </div>
      </div>
      <div class="col-7">
        <app-header icon="fas fa-palette" text="Farben und Klassen" />
        <div class="grid align-items-center">
          <app-colorset-dropdown
            [label]="'Standardfarbset'"
            [name]="'colorSet'"
            [colSize]="8"
            formControlName="colorSet"></app-colorset-dropdown>
          <app-form-field-wrapper
            [colSize]="4"
            [label]="'Farbset invertieren'"
            name="invert"
            [floatingLabel]="false"
            [hideLabel]="true">
            <p-checkbox
              class="pt-5"
              inputId="invert"
              formControlName="invert"
              [binary]="true"
              label="Farbset invertieren"></p-checkbox>
          </app-form-field-wrapper>

          <app-form-field-wrapper
            [colSize]="5"
            [label]="'Klassenmodus'"
            [name]="'legendMode'">
            <p-dropdown
              id="legendMode"
              formControlName="legendMode"
              [options]="legendModes"
              optionLabel="name"
              optionValue="key"></p-dropdown>
          </app-form-field-wrapper>

          @if (form.value.legendMode === 'fixed') {
            @if (!form.value.colorSet) {
              <div
                class="text-color-secondary flex align-items-center gap-2 col-12 font-italic">
                <i class="fas fa-info-circle"></i> Bitte wählen Sie ein
                Standardfarbset aus.
              </div>
            }
            <app-legend-form
              [legendFormArray]="legendFormArray"
              [invert]="form.get('invert')?.value"
              [colorsetId]="form.value.colorSet"
              [legendData]="itemToEdit?.legend || []">
            </app-legend-form>
          }
        </div>
      </div>
    </div>

    <p-divider></p-divider>

    <app-form-footer
      [cancelLevel]="2"
      [showRemoveButton]="
        !!(
          itemToEdit &&
          indicator &&
          permissionService.checkIndicatorRights(indicator.category, 'remove')
        )
      "
      [isEditMode]="!!itemToEdit"
      (removeClick)="
        itemToEdit
          ? confirm(undefined, itemToEdit, indicator ? indicator.name : '')
          : undefined
      "></app-form-footer>
  </form>
}
